module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/kind_icons/new_pickem-1e3a67ea46fdae41e215774838bcad9c.svg";